export const SET_CALENDAR_OPTION = 'SCHEDULING/SET_CALENDAR_OPTION';
export const SET_CALENDAR_LIST = 'SCHEDULING/SET_CALENDAR_LIST';
export const SET_MAP_LIST = 'SCHEDULING/SET_MAP_LIST';
export const SET_IS_MAP_SELECTED = 'SCHEDULING/SET_IS_MAP_SELECTED';
export const SET_IS_FIRST_SCHEDULING_ACCESS = 'SCHEDULING/SET_IS_FIRST_SCHEDULING_ACCESS'
export const SET_IS_LOADING = 'SCHEDULING/SET_IS_LOADING';